import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";
import FeeScheduleTag from "_shared/fee-schedules/tags/fee-schedule-tag";
import Guid from "_shared/guids/guid";
import FeeScheduleSchema, { FeeScheduleJSON, FeeScheduleParams } from "marketplace/teams/fee-schedules/_schemas/fee-schedule-schema";

export default class FeeSchedule {
  public static create(values: FeeScheduleParams): FeeSchedule {
    const parsed = FeeScheduleSchema.validate(values);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid FeeSchedule parameters.");
    }
    return new FeeSchedule(parsed);
  }

  public static fromJSON(json: FeeScheduleJSON): FeeSchedule {
    if (isNullOrUndefined(json)) return json;
    const params = FeeScheduleSchema.deserialize(json);
    return new FeeSchedule(params);
  }

  public static fromJSONArray(
    jsonArray: FeeScheduleJSON[]
  ): FeeSchedule[] {
    return jsonArray.map(json => FeeSchedule.fromJSON(json));
  }

  public readonly id: Guid;
  public readonly name: string;
  public readonly tags: FeeScheduleTag[] = [];
  public readonly categories: FeeScheduleCategory[] = [];

  /** Reads as a sentence beside the name, so a one-category schedule doesn't say "1 categories". */
  public get categoryCountLabel(): string {
    return this.categories.length === 1 ? "1 category" : `${this.categories.length} categories`;
  }

  public constructor(params: FeeScheduleParams) {
    this.name = params.name;
    this.id = params.id ?? Guid.generate();
    this.tags = params.tags ?? [];
    this.categories = params.categories
      ?.map(cat => FeeScheduleCategory.create(cat))
      .filter((cat): cat is FeeScheduleCategory => cat instanceof FeeScheduleCategory) ?? [];
  }
}
  